<template>
<v-container>
<v-row>
  <!--
  {{pageCount}}

  <v-col cols="12" v-for="i in 18" :key="i">
    <pdf src="https://firebasestorage.googleapis.com/v0/b/precheckin-1466b.appspot.com/o/docs%2FCONTRATTO%20IL%20FARO-IL%20FARO%20HOUSING.pdf?alt=media&token=fc975353-366b-46f6-9e0d-f0d357452017"
      :page="i"
      @num-pages="pageCount = $event"
      @page-loaded="currentPage = $event"></pdf>
      



  </v-col>
  -->
  <v-col  cols="12" v-if="$store.state.prenotazionehr">
  <v-card>
    <v-card-title>{{labels.riepilogo_prenotazione}}</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          {{labels.data_arrivo}}: <strong>{{$store.state.prenotazionehr.Arrivo}}</strong>
        </v-col>
        <v-col>
          {{labels.data_partenza}}: <strong>{{$store.state.prenotazionehr.Partenza}}</strong>
        </v-col>
      </v-row>
      
      <v-row v-for="risorsa in $store.state.prenotazionehr.Risorse" :key="risorsa.IdRisorsa">
        <v-col cols="12">
          {{labels.struttura}}: <strong> {{ risorsa.DescrizioneEstesaStruttura }}</strong>
        </v-col>
        <v-col cols="12">
          {{labels.alloggio}}: <strong> {{risorsa.DescrizioneEstesaTipologia}}</strong>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          {{labels.totale}}:  <strong> € {{Number($store.state.prenotazionehr.Totale/100).toFixed(2)}}</strong>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
   </v-col>

  <v-col  cols="12">
  <v-card>
    <v-card-title>{{labels.regolamento}}</v-card-title>
    <v-card-text>
      <div v-html="testocontratto()"/>
    </v-card-text>
    <div>
      <v-checkbox 
        :label="labels.ho_preso_visione"
        v-model="contratto_letto"> 
      </v-checkbox>
    </div>
  </v-card>
   </v-col>
  <v-col  cols="12" v-if="urlcontratto">
    <v-card>
      <v-card-text>
        <div v-html="testopostcontratto()"/>
      </v-card-text>
      <v-btn style="margin:3px" :href="urlcontratto">{{labels.contratto}}<v-icon>mdi-download</v-icon></v-btn>
    </v-card>
     
  </v-col>
  
  <v-progress-linear v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>

  <v-col cols="12"  v-if="!contratto_letto">
    <v-card ma-3 pa-3>
      <v-card-text>
        <h4  text-center>
         {{labels.conferma_e_firma}}
        </h4>
        </v-card-text>
    </v-card>
  </v-col>
  <v-col cols="12" v-if="!urlcontratto">
  <v-card ma-3 v-if="contratto_letto">
    <v-card-title>{{labels.firma_qui}}</v-card-title>
    <VueSignaturePad
      width="95%"
      height="150px"
      ref="signaturePad"
      :options="{ onBegin, onEnd }"
    />
    <v-card-actions>
          <v-btn dark color="red" @click="undo" ><v-icon dark large>backspace</v-icon></v-btn>
          <v-btn dark color="green" @click="next" ><v-icon dark large>check</v-icon></v-btn>
    </v-card-actions>
    </v-card>
    </v-col>
        <div v-if="errore">
          devi firmare
      <!--<v-btn @click="save">Save</v-btn>-->
        <!--<v-btn @click="lock_pad">Lock</v-btn>
      <v-btn @click="open_pad">Unlock</v-btn>
      -->
    </div>
</v-row>
  <v-snackbar
      v-model="snackbar"
    >
      Operazione eseguita correttamente

      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
</v-container>
</template>
<script>
import Vue from 'vue';
import VueSignaturePad from 'vue-signature-pad';
//import pdf from 'vue-pdf'

Vue.use(VueSignaturePad);


export default {
  data: () => ({
    errore: false,
    currentPage: 0,
    pageCount: 0,
    urlcontratto:null,
    snackbar:false,
    loading:false,
    contratto_letto:false
  }),
    components: {
    //pdf
  },

  computed:{
    labels(){
      return this.$store.state.labels;
    }
  },
  methods: {
    testocontratto(){
     return  this.espanditestocontratto(this.$store.getters.currentconfig.ContractText)
    },
    testopostcontratto(){
     return  this.espanditestocontratto(this.$store.getters.currentconfig.PostContractText)
    },

      espanditestocontratto(testobase){
        //let testo = this.$store.getters.currentconfig.ContractText;
        let testo = testobase;
        console.log("testo contr",testo)

        //cerco i tag racchiusi tra parentesi graffe
        var pattern = /[^{}]*(?=\})/g;
        var items =testo.match(pattern);

        //valorizzo i tag dell'ospite
        for (const key in items) {
          var ele = items[key]
          if(ele!=''){
            console.log("KEY: ", ele)
            let valore =''
            if(ele.includes('.')){
                const keyval = ele.split('.');
                const element = this.$store.state.reservation.mainguest[keyval[0]];
                if(element){
                 valore = element[keyval[1]]
                }

              }
              else{
                const element = this.$store.state.reservation.mainguest[ele];      
                valore = element
              }

              //se ho trovato un dato, altrimenti sbianco il testo corrispondente al tag
              if(valore){
                 testo = testo.replace('{'+ele+'}',valore)
              }
              else{
                testo = testo.replace('{'+ele+'}','')
              }

          }



        }

        return testo;

      },
      undo() {
        this.$refs.signaturePad.undoSignature();
      },
      open_pad() {
        this.$refs.signaturePad.openSignaturePad();
      },
      lock_pad() {
        this.$refs.signaturePad.lockSignaturePad();
      },
      next() {
        if(!this.$refs.signaturePad.isEmpty()){
          this.save();
         // console.log("next");
         // this.$store.commit("GOTONEXTSTEP", {from:'firma'});
        }else
        {
          this.errore = true;
          console.log("firma vuota")
        }

    },
      save() {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        console.log(isEmpty);
        console.log(data);

        var payload ={
            "Comando":"FirmaContrattoPren",
            "Lingua": this.$store.state.currentlan.toUpperCase(),
            "Firma":data
            }
            this.loading = true
            console.log("FirmaCotratto",payload)
        this.$store.dispatch("APIRequestHR",payload).then(x=>{
          console.log("FirmaCotratto Risp",x)
          if(x.data.RISPOSTAOK==-1){
                console.log('DATICONTR',x.data.RISULTATOJSON);
                this.snackbar = true
                x.data.RISULTATOJSON.forEach(c => {
                  if(c.VisibileSuChekinOnline){
                    this.urlcontratto = c.PathWeb
                  }
                });
                
                this.$store.dispatch('setContrattofirmato',{url:this.urlcontratto});
             }
          this.loading = false
        })

        //this.$store.commit('SET_IMMAGINE',{tipo:'firma',dati:data});
        //this.$store.dispatch('salvaimmagine',{tipo:'firma',dati:data});
      },
    onBegin() {
      console.log('=== Begin ===');
    },
    onEnd() {
      this.errore = false
      console.log('=== End ===');
    }
  }
};
</script>